import ReedsyExitModal from '@reedsy/exit-modal';
import LocalStorage from '@d-shared/utils/local-storage';

import SASS from '@dui/helpers/sass';

const EXIT_MODAL_ID = 'exit-modal';
const TIMEOUT_MS = 250;

export class ExitModalHandler {
  constructor (vue) {
    this._vue = vue;
    this._exitModal = null;
    this._currentScrollTop = null;

    this._scrollingElement = document.scrollingElement;

    this.windowScrollPerformed = this.windowScrollPerformed.bind(this);
    this.initialize = this.initialize.bind(this);
    this.initAndShow = this.initAndShow.bind(this);
    this.callbackTriggered = this.callbackTriggered.bind(this);

    this.setup();
  }

  callbackTriggered() {
    if (this._vue.prototype.trackingHandler &&
      this._vue.prototype.trackingHandler.exitModalShown) {
      this._vue.prototype.trackingHandler.exitModalShown(EXIT_MODAL_ID);
    }

    this._vue.prototype.modalHandler.show(`#${ EXIT_MODAL_ID }`);
    this.deactivateExitModal();
  }

  deactivateExitModal() {
    if (!this._exitModal) {
      return;
    }

    this._exitModal.destroy();
    window.removeEventListener('scroll', this.windowScrollPerformed);
  }

  hideModal() {
    if (!this._exitModal) {
      return;
    }

    this._exitModal.hide();
  }

  initialize(modalId = EXIT_MODAL_ID, auto = true) {
    const exitModalElement = document.getElementById(modalId);
    if (!exitModalElement) {
      return;
    }

    const modalKey = exitModalElement.dataset.modalKey || null;
    const modal = new ReedsyExitModal(modalId, {
      callback: this.callbackTriggered,
      classes: {
        hidden: 'normal',
        visible: 'active',
      },
      key: modalKey,
      reenableAfter: {
        type: 'weeks',
        value: 2,
      },
      reenableOnNewSession: true,
    });

    /* istanbul ignore next */
    if (modal._isDisabled) {
      modal.destroy();
      return null;
    }

    this._exitModal = modal;

    this.initMobileScrollActivation(modal);

    return auto ? true : modal;
  }

  initAndShow(modalId = EXIT_MODAL_ID) {
    const modal = this.initialize(modalId, false);
    if (!modal) return;
    modal.show(true);
  }

  initMobileScrollActivation(modal) {
    // Activate on mobile only
    if (window.innerWidth >= SASS.screenSize.md) {
      return;
    }

    if (modal._element.dataset.showAtPosition
      && (modal._element.dataset.showOnScrollDirection === 'up'
        || modal._element.dataset.showOnScrollDirection === 'down')) {
      window.addEventListener('scroll', this.windowScrollPerformed);
    }
  }

  setup() {
    this._currentScrollTop = this._scrollingElement.scrollTop;

    setTimeout(this.initialize, TIMEOUT_MS);
  }

  windowScrollPerformed() {
    if (!this._exitModal) {
      return;
    }

    const newScrollTop = this._scrollingElement.scrollTop;

    // Only fire if the scroll changes more than 10px
    if (Math.abs(newScrollTop - this._currentScrollTop) <= 10) {
      return;
    }

    const showOnScrollPosition = parseInt(this._exitModal._element.dataset.showAtPosition);

    if (newScrollTop < showOnScrollPosition) {
      return;
    }

    const shouldShowModal = (this._exitModal._element.dataset.showOnScrollDirection === 'up' &&
      newScrollTop < this._currentScrollTop) ||
      (this._exitModal._element.dataset.showOnScrollDirection === 'down' &&
        newScrollTop > this._currentScrollTop);

    if (shouldShowModal) {
      this._exitModal.show(true);
      this.deactivateExitModal();
    }

    this._currentScrollTop = newScrollTop;
  }
}

export default {
  install: function(Vue, options) {
    Vue.prototype.exitModalHandler = new ExitModalHandler(Vue);
  },
};
